var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-icon',{staticClass:"play-button",attrs:{"type":"undo"},on:{"click":_vm.replay}})}
var staticRenderFns = []

export { render, staticRenderFns }